var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-heading',{attrs:{"show":true,"pageTitle":"CATALOG-ONLINE-NEW_PRODUCTS"}}),_c('loading-indicator',{attrs:{"loading":_vm.isLoading}}),(!_vm.isLoading)?[_vm._m(0)]:_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"col-main"},[_c('div',{staticClass:"box"})])])
}]

export { render, staticRenderFns }